"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setBackgroundOfPaintObjects = void 0;
var tslib_1 = require("tslib");
var utils_1 = require("../../utils");
var setBackgroundOfPaintObjects = function (backgroundOfPaintObjects, paintObjects) {
    var e_1, _a;
    var width = backgroundOfPaintObjects.width, height = backgroundOfPaintObjects.height;
    var bgAt = function (x, y) { return y * width + x; };
    var bgDataTemp = new Uint8Array(width * height);
    bgDataTemp.fill(1);
    var _loop_1 = function (paint) {
        var _d = paint.bitMatrix, w = _d.width, h = _d.height, data = _d.data;
        var top_1 = paint.pixelTop;
        var left = paint.pixelLeft;
        var at = function (x, y) { return y * w + x; };
        for (var y = 0; y < h; ++y) {
            for (var x = 0; x < w; ++x) {
                if (data.get(at(x, y), 0) > 0) {
                    bgDataTemp[bgAt(x + left, y + top_1)] = 0; // not background
                }
            }
        }
    };
    try {
        for (var _b = tslib_1.__values(paintObjects.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var paint = _c.value;
            _loop_1(paint);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return backgroundOfPaintObjects.set('data', (0, utils_1.ReadonlyBitArray)(bgDataTemp));
};
exports.setBackgroundOfPaintObjects = setBackgroundOfPaintObjects;
